import axiosInstance from './axios';

export interface CompanyStats {
    activeVehicles: number;
    totalSpaces: number;
    freeSpaces: number;
    incomeToday: number;
    activeShifts: number;
    charts?: {
        occupancyHistory: { time: string; count: number }[];
        revenueByMethod: { name: string; value: number }[];
        vehiclesByType: { name: string; value: number }[];
    };
}

export interface GlobalStats {
    activeCompanies: number;
    totalCompanies: number;
    monthlyRevenue: number;
    activeSubscriptions: number;
    totalUsers: number;
    totalVehicles: number;
    movementsToday: number;
    occupancyRate?: number;
    freeSpaces?: number;
    planDistribution: {
        plan: string;
        count: number;
        color?: string;
    }[];
    recentCompanies: {
        id: string;
        name: string;
        plan: string;
        status: string;
        date: string;
        revenue: number;
    }[];
}

export const getCompanyStats = async (): Promise<CompanyStats> => {
    const response = await axiosInstance.get<CompanyStats>('/stats/company');
    return response.data;
};

export const getGlobalStats = async (): Promise<GlobalStats> => {
    const response = await axiosInstance.get<GlobalStats>('/stats/global');
    return response.data;
};
